export enum PlaceDataSubmissionStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  UNDER_REVIEW = "UNDER_REVIEW",
  DUPLICATE = "DUPLICATE",
  UNKNOWN = "UNKNOWN",
}
